import { FC, useContext, useEffect, useRef, useState } from 'react';
import './UserManagementStyles.scss';
import UserOnboardingWizard from './wizard/UserOnboardingWizard';
import di from '../../../../../../di/DependencyInjection';
import SearchAllUserUseCase, { SearchAllUserUseCaseName } from '../../../../../../domain/use_cases/user/SearchAllUserUseCase';
import { isRight } from 'fp-ts/lib/Either';
import SearchDropdown from './dropDownInput';
import GetAllRolesUseCase, { GetAllRolesUseCaseName } from '../../../../../../domain/use_cases/roles/GetAllRolesUseCase';
import SearchUserPositionsUseCase, { SearchUserPositionsUseCaseName } from '../../../../../../domain/use_cases/user/SearchUserPositionsUseCase';
import SearchUserBUnitsUseCase, { SearchUserBUnitsUseCaseName } from '../../../../../../domain/use_cases/user/SearchUserBUnitsUseCase';
import ButtonComponent from '../../../../../components/button/ButtonComponent';
import { ButtonType } from '../../../../../components/button/ButtonComponentProps';
import Icons from '../../../../../assets/Icons';
import SearchAlSupervisorsUseCase, { SearchAlSupervisorsUseCaseName } from '../../../../../../domain/use_cases/user/SearchAlSupervisorsUseCase';
import LoadingComponent from '../../../../../components/LoadingComponent/LoadingComponent';
import Papa from 'papaparse';
import DropDownComponent from '../../../../../components/dropDown/DropDownComponent';
import { DropDownType } from '../../../../../components/dropDown/DropDownComponentProps';
import { AutoCompleteItem } from '../../../../../components/forms/autocompleteWithCheck/AutoCompleteWithCheckProps';
import TypeEventScheduleEntity from '../../../../../../domain/entities/TypeEventScheduleEntity';
import CreateUserUseCase, { CreateUserUseCaseName } from '../../../../../../domain/use_cases/user/CreateUserUseCase';
import ProvisionUserUseCase, { ProvisionUserUseCaseName } from '../../../../../../domain/use_cases/user/ProvisionUserUseCase';
import { ProvisionUserPayload } from '../../../../../../domain/entities/ProvisionUserEntity';
import ModalsContext from '../../../../../../domain/providers/modal/ModalsContext';
import ModalsContextType from '../../../../../../domain/providers/modal/ModalsContextType';
import Constants, { ConstantsName } from '../../../../../../constants/Constants';
import { Auth } from 'aws-amplify';
import { BucketNode } from './BucketTreePicker';

const defaultTimeZones: any =  [
    { label: "America/Belize", subLabel: "" },
    { label: "America/Bogota", subLabel: "" },
    { label: "America/Jamaica", subLabel: "" },
    { label: "America/Tegucigalpa", subLabel: "" },
    { label: "America/Guyana", subLabel: "" },
    { label: "America/St_Lucia", subLabel: "" },
    { label: "US/Eastern", subLabel: "" },
    { label: "US/Central", subLabel: "" },
    { label: "US/Mountain", subLabel: "" },
    { label: "US/Pacific", subLabel: "" },
    { label: "US/Alaska", subLabel: "" }
];

const defaultLocationsOptions = [
    { label: "Belize", subLabel: "" },
    { label: "Jamaica", subLabel: "" },
    { label: "Colombia", subLabel: "" },
    { label: "Guyana", subLabel: "" },
    { label: "Saint Lucia", subLabel: "" },
    { label: "US", subLabel: "" },
    { label: "Honduras", subLabel: "" },
    {label: "Training", subLabel: ""}
]

const UserUpdatePage: FC<{}> = () => {
    const [selectedUsers, setSelectedUsers] = useState<any>(
        {
            role: "",
            position: "",
            business_unit: "",
            timezone: "",
            location: "",
            client: "" ,
            supervisor: ""
        }
    );
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const [ allUsersData, setAllUsersData ] = useState<any>([]); // eslint-disable-line @typescript-eslint/no-unused-vars
    const [ allRolesData, setAllRolesData ] = useState<any>([]);
    const [ allPositionsData, setAllPositionsData ] = useState<any>([]);
    const [ allBUnitsData, setAllBUnitsData ] = useState<any>([]);
    const [ allSupervisorsData, setAllSupervisorsData ] = useState<any>([]);

    const [ loadingUpdate, setLoadingUpdate ] = useState(false);
    const [ isSubmitting, setIsSubmitting ] = useState(false);

    const [ showLocationField, setShowLocationField ] = useState(true);
    const [ showClientField, setShowClientField ] = useState(true);
    const [ showSupervisorField, setShowsupervisorField ] = useState(true);

    const [ openDropView, setOpenDropView ] = useState(false);

    const [ usersPreview, setUsersPreview ] = useState<any>([]);
    const [ userButtonSelected, setUserButtonSelected ] = useState<string>("");
    const [ userSelected, setUserSelected ] = useState<string>("");
    const [ allUsersInfo, setAllUsersInfo ] = useState<any[]>([]);

    const dropdownRef = useRef<HTMLDivElement>(null);

    const [ roleBucket, setRoleBucket ] = useState<string>("");
    const [ positionBucket, setPositionBucket ] = useState<string>("");
    const [ businessUnitBucket, setBusinessUnit ] = useState<string>("");
    const [ timeZoneBucket, setTimeZoneBucket ] = useState<string>("");
    const [ locationBucket, setLocationBucket ] = useState<string>("");
    const [ clientBucket, setClientBucket ] = useState<string>(""); // eslint-disable-line @typescript-eslint/no-unused-vars
    const [ supervisorBucket, setSupervisorBucket ] = useState<string>("");
    
    const [ allUsersAllDataInfo, setAllUsersAllDataInfo ] = useState<any[]>([]); // eslint-disable-line @typescript-eslint/no-unused-vars

    // Raw data with IDs for name-to-ID resolution
    const [ allRolesRaw, setAllRolesRaw ] = useState<any[]>([]);
    const [ allPositionsRaw, setAllPositionsRaw ] = useState<any[]>([]);
    const [ allBUnitsRaw, setAllBUnitsRaw ] = useState<any[]>([]);

    // Config-driven dropdown options (from GET /config)
    const [ configTimeZones, setConfigTimeZones ] = useState<any[]>(defaultTimeZones);
    const [ configLocations, setConfigLocations ] = useState<any[]>(defaultLocationsOptions);
    const [ configClients, setConfigClients ] = useState<any[]>([]);

    // Bucket tree picker state
    const [ bucketTreeData, setBucketTreeData ] = useState<BucketNode[]>([]); // eslint-disable-line @typescript-eslint/no-unused-vars
    const [ bucketTreeLoading, setBucketTreeLoading ] = useState<boolean>(false); // eslint-disable-line @typescript-eslint/no-unused-vars
    const [ bucketTreeError, setBucketTreeError ] = useState<string | null>(null); // eslint-disable-line @typescript-eslint/no-unused-vars
    const [ selectedBucketIds, setSelectedBucketIds ] = useState<number[]>([]);
    const [ bucketSelectionMode, setBucketSelectionMode ] = useState<'text' | 'tree'>('text'); // eslint-disable-line @typescript-eslint/no-unused-vars

    // Single-user form fields for provisioning
    const [ firstnameBucket, setFirstnameBucket ] = useState<string>("");
    const [ lastnameBucket, setLastnameBucket ] = useState<string>("");

    const _search = async () => (await di.get<SearchAllUserUseCase>(SearchAllUserUseCaseName).call(''));
    const _searchRole = async () => await di.get<GetAllRolesUseCase>(GetAllRolesUseCaseName).call(true);
    const _searchPositions = async () => await di.get<SearchUserPositionsUseCase>(SearchUserPositionsUseCaseName).call();
    const _searchBUnits = async () => await di.get<SearchUserBUnitsUseCase>(SearchUserBUnitsUseCaseName).call();
    const _searchSupervisors = async () => await di.get<SearchAlSupervisorsUseCase>(SearchAlSupervisorsUseCaseName).call();

    const { addToast } = useContext(ModalsContext) as ModalsContextType;

    const firstCall = async () => {
        setLoadingUpdate(true);
        const first = await _search();
        const firstRole = await _searchRole();
        const firstPositions = await _searchPositions();
        const firstBUnits = await _searchBUnits();
        const firstSupervisors = await _searchSupervisors();

        // Fetch bucket tree hierarchy
        try {
            setBucketTreeLoading(true);
            const baseUrl2 = di.get<Constants>(ConstantsName).HOST_API_USERS_URL;
            const session2 = await Auth.currentSession();
            const token2 = session2.getIdToken().getJwtToken();
            const treeResponse = await fetch(`${baseUrl2}/buckets/tree`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'Authorization': token2 },
            });
            if (treeResponse.ok) {
                const treeData = await treeResponse.json();
                setBucketTreeData(treeData || []);
                setBucketTreeError(null);
            } else {
                setBucketTreeError('Failed to load bucket hierarchy');
            }
        } catch (e) {
            setBucketTreeError('Failed to load bucket hierarchy');
        } finally {
            setBucketTreeLoading(false);
        }

        // Fetch config options (timezones, locations, clients) from GET /config
        try {
            const baseUrl3 = di.get<Constants>(ConstantsName).HOST_API_USERS_URL;
            const session3 = await Auth.currentSession();
            const token3 = session3.getIdToken().getJwtToken();
            const configResponse = await fetch(`${baseUrl3}/config`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'Authorization': token3 },
            });
            if (configResponse.ok) {
                const configData = await configResponse.json();
                if (configData.timezone && Array.isArray(configData.timezone)) {
                    setConfigTimeZones(configData.timezone.map((tz: string) => ({ label: tz, subLabel: "" })));
                }
                if (configData.location && Array.isArray(configData.location)) {
                    setConfigLocations(configData.location.map((loc: string) => ({ label: loc, subLabel: "" })));
                }
                if (configData.client && Array.isArray(configData.client)) {
                    setConfigClients(configData.client.map((cl: string) => ({ label: cl, subLabel: "" })));
                }
            }
        } catch (e) {
            // Fall back to existing hardcoded arrays if the config endpoint fails
        }

        if (isRight(first)) {
            let userDataFormat = first.right.map((user: any) => {
                return {
                    label: user.firstname + " " + user.lastname,
                    subLabel: user.email
                }
            });
            setAllUsersData(userDataFormat);
            setAllUsersAllDataInfo(first.right);

        }
        if(isRight(firstRole)){
            setAllRolesRaw(firstRole.right);
            let userDataFormat = firstRole.right.map((role: any) => {
                return {
                    label: role.name,
                    subLabel: ""
                }
            });
            setAllRolesData(userDataFormat);
        }

        if(isRight(firstPositions)) {
            setAllPositionsRaw(firstPositions.right);
            let userDataFormat = firstPositions.right.map((position: any) => {
                return {
                    label: position.name,
                    subLabel: ""
                }
            });
            setAllPositionsData(userDataFormat);
        }
        if(isRight(firstBUnits)) {
            setAllBUnitsRaw(firstBUnits.right);
            let userDataFormat = firstBUnits.right.map((BUnit: any) => {
                return {
                    label: BUnit.name,
                    subLabel: ""
                }
            });
            setAllBUnitsData(userDataFormat);
        }
        if (isRight(firstSupervisors)) {
            let userDataFormat = firstSupervisors.right.map((user: any) => {
                return {
                    label: user.firstname + " " + user.lastname,
                    subLabel: user.email
                }
            });
            setAllSupervisorsData(userDataFormat);
        }
        setLoadingUpdate(false);
    }

    let supervisorOptionsToSeeField = ['Agent'];
    let clientOptionsToSeeField = ['Senior Agent', 'Agent', 'Supervisor', 'Manager', 'Client Basic', 'Client Advanced'];
    let locationOptionsToSeeField = ['Senior Agent', 'Agent', 'Supervisor', 'Manager', 'Client Basic', 'Client Advanced'];

    const handleItemSelect = async (user: any, id: string) => {

        if (allUsersInfo.length > 0) {

            if (id === 'role') setRoleBucket(user.label);
            if (id === 'position') setPositionBucket(user.label);
            if (id === 'timezone') setTimeZoneBucket(user.label);
            if (id === 'business_unit') setBusinessUnit(user.label);
            if (id === 'location') setLocationBucket(user.label);
            if (id === 'client') setClientBucket(user.label);
            if (id === 'supervisor') setSupervisorBucket(user.label);

            const userToChange = allUsersInfo.filter(user => user.email.toLowerCase() === userSelected.toLowerCase())[0];
            let newUserInfo = {
                ...userToChange,
                [id]: userToChange[id].toLowerCase().includes(user.label.toLowerCase()) ? userToChange[id] :  (userToChange[id] + "," + user.label).split(",").filter(item => item !== "").join(",")
            }

            setSelectedUsers(newUserInfo);
            

            const updatedArray = allUsersInfo.map(item =>
                item.email.toLowerCase() === newUserInfo.email.toLowerCase() ? newUserInfo : item
            );

            setAllUsersInfo(updatedArray);
                
        } else {
            let newUser = {
                name: user.label,
                subName: user.subLabel
            }
            setSelectedUsers(() => {
                
                return {
                    ...selectedUsers,
                    [id]: (id === "email") ? 
                        newUser.subName 
                        : 
                        (id === "location" || id === "client" || id === "supervisor") ? 
                            selectedUsers[id].includes(newUser.name) ? selectedUsers[id] : (selectedUsers[id] + "," + newUser.name).split(",").filter(item => item !== "").join(",") 
                            :
                            newUser.name,
                };
            });

            setDropdownOpen(false);

            if (id === "role") {
                let isSuperLevel = supervisorOptionsToSeeField.filter(item => item.toLowerCase().replaceAll(" ", "") === user.label.toLowerCase().replaceAll(" ", ""));
                if (isSuperLevel.length > 0) {
                    setShowsupervisorField(true);
                } else {
                    setShowsupervisorField(false);
                }
                let isLocationLevel = locationOptionsToSeeField.filter(item => item.toLowerCase().replaceAll(" ", "") === user.label.toLowerCase().replaceAll(" ", ""));
                if (isLocationLevel.length > 0) {
                    setShowLocationField(true);
                } else {
                    setShowLocationField(false);
                }
                let isClientLevel = clientOptionsToSeeField.filter(item => item.toLowerCase().replaceAll(" ", "") === user.label.toLowerCase().replaceAll(" ", ""));
                if (isClientLevel.length > 0) {
                    setShowClientField(true);
                } else {
                    setShowClientField(false);
                }
            }
        }

    };

    const handleClickOutside = (event: MouseEvent) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
            setDropdownOpen(false);
        }
    };

    const _handleUpdateUsers = async () => {
        
        if (isSubmitting) return;
        setIsSubmitting(true);

        // 30-second UI-level timeout safeguard
        const timeoutId = setTimeout(() => {
            setIsSubmitting(false);
            addToast("Request timed out. Please try again.", "error", undefined);
        }, 30000);

        try {
            // Single-user mode: call the new /provision-user endpoint
            if (allUsersInfo.length === 0) {
                // Resolve display names to numeric IDs
                const roleMatch = allRolesRaw.find((r: any) => r.name.toLowerCase() === selectedUsers.role.toLowerCase());
                const positionMatch = allPositionsRaw.find((p: any) => p.name.toLowerCase() === selectedUsers.position.toLowerCase());
                const buMatch = allBUnitsRaw.find((b: any) => b.name.toLowerCase() === selectedUsers.business_unit.toLowerCase());

                if (!selectedUsers.email || !firstnameBucket || !lastnameBucket) {
                    addToast("Email, First Name, and Last Name are required", "error", undefined);
                    clearTimeout(timeoutId);
                    setIsSubmitting(false);
                    return;
                }
                if (!roleMatch) {
                    addToast("Please select a valid role", "error", undefined);
                    clearTimeout(timeoutId);
                    setIsSubmitting(false);
                    return;
                }
                if (!positionMatch) {
                    addToast("Please select a valid position", "error", undefined);
                    clearTimeout(timeoutId);
                    setIsSubmitting(false);
                    return;
                }
                if (!buMatch) {
                    addToast("Please select a valid business unit", "error", undefined);
                    clearTimeout(timeoutId);
                    setIsSubmitting(false);
                    return;
                }

                const payload: ProvisionUserPayload = {
                    email: selectedUsers.email.trim(),
                    firstname: firstnameBucket.trim(),
                    lastname: lastnameBucket.trim(),
                    role_id: Number(roleMatch.id),
                    bu_id: Number(buMatch.bu_id),
                    position_id: Number(positionMatch.position_id),
                    ...(timeZoneBucket && { timezone: timeZoneBucket }),
                    ...(bucketSelectionMode === 'tree' && selectedBucketIds.length > 0
                        ? { bucket_ids: selectedBucketIds }
                        : {
                            ...(selectedUsers.location && { location: selectedUsers.location }),
                            ...(selectedUsers.client && { client: selectedUsers.client }),
                            ...(selectedUsers.supervisor && { supervisor: selectedUsers.supervisor }),
                        }
                    ),
                };

                const _provisionUser = async () => await di.get<ProvisionUserUseCase>(ProvisionUserUseCaseName).call(payload);
                const response: any = await _provisionUser();

                clearTimeout(timeoutId);

                if (response._tag === "Right") {
                    addToast(`User ${payload.email} provisioned successfully (user_id: ${response.right.user_id})`, "success", undefined);
                    // Clear form fields
                    setSelectedUsers({ role: "", position: "", business_unit: "", timezone: "", location: "", client: "", supervisor: "" });
                    setFirstnameBucket("");
                    setLastnameBucket("");
                    setRoleBucket("");
                    setPositionBucket("");
                    setBusinessUnit("");
                    setTimeZoneBucket("");
                    setLocationBucket("");
                    setClientBucket("");
                    setSupervisorBucket("");
                    setSelectedBucketIds([]);

                    // Fire-and-forget: post-provisioning verification via GET /users/<id>/profile
                    const userId = response.right.user_id;
                    (async () => {
                        try {
                            const baseUrl = di.get<Constants>(ConstantsName).HOST_API_USERS_URL;
                            const sess = await Auth.currentSession();
                            const tk = sess.getIdToken().getJwtToken();
                            const profileResponse = await fetch(`${baseUrl}/users/${userId}/profile`, {
                                method: 'GET',
                                headers: { 'Content-Type': 'application/json', 'Authorization': tk },
                            });
                            if (profileResponse.ok) {
                                const profileData = await profileResponse.json();
                                const roleName = profileData?.role?.name || 'N/A';
                                const bucketPath = profileData?.bucket_path || profileData?.buckets?.map((b: any) => b.path || b.name).join(', ') || 'N/A';
                                addToast(`Verified: Role "${roleName}" | Bucket: ${bucketPath}`, "default", undefined);
                            }
                        } catch (_) {
                            // Verification is optional — do not block or show error if it fails
                        }
                    })();
                } else {
                    const errorCode = response.left.code;
                    const errorMessage = response.left.message || 'An unexpected error occurred';

                    switch (errorCode) {
                        case '400':
                            // Field-level validation errors (formatted as "field: message; field: message")
                            addToast(`Validation failed: ${errorMessage}`, "error", undefined);
                            break;
                        case '409':
                            // User already exists with existing user_id/systemid
                            addToast(`User already exists: ${errorMessage}`, "error", undefined);
                            break;
                        case '403':
                            // Permission or role hierarchy error
                            addToast(`Access denied: ${errorMessage}`, "error", undefined);
                            break;
                        case '500':
                            // Server/transaction error
                            addToast(`Server error: ${errorMessage}`, "error", undefined);
                            break;
                        case 'TIMEOUT':
                            // Request timed out
                            addToast('Request timed out. Please try again.', "error", undefined);
                            break;
                        default:
                            addToast(errorMessage, "error", undefined);
                            break;
                    }
                }

                setIsSubmitting(false);
                return;
            }

            // CSV bulk mode: use existing /usersetup endpoint
            let dataToSend: any = allUsersInfo;
            
            try {
                dataToSend = dataToSend.map((item: any) => {
                    return {
                        ...item,
                        'hr_id': item['hr_id'] ? +item['hr_id'] : '',
                        'role': item['role'] ? item['role'].replaceAll(" ", "_") : '',
                    }
                });
            } catch (error) {
                dataToSend = {
                    ...dataToSend,
                    'hr_id': (dataToSend as any)['hr_id'] ? +(dataToSend as any)['hr_id'] : '',
                    'role': (dataToSend as any)['role'] ? (dataToSend as any)['role'].replaceAll(" ", "_") : '',
                }
            }

            const _updateUsers = async () => await di.get<CreateUserUseCase>(CreateUserUseCaseName).call(dataToSend);

            const response: any = await _updateUsers();

            clearTimeout(timeoutId);

            if (response._tag === "Right") {
                const rightResponse = response.right;
                addToast(rightResponse.message, "success", undefined);
            } else {
                addToast(response.left.message, "error", undefined);
            }

            setIsSubmitting(false);
        } catch (error) {
            clearTimeout(timeoutId);
            setIsSubmitting(false);
            addToast("An unexpected error occurred. Please try again.", "error", undefined);
        }
    }

    const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        if (file) {
        handleFileUpload(file);
        }
    };

    const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
    };

    const _openDropView = () => {
        setOpenDropView(!openDropView);
    }

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files ? event.target.files[0] : null;
        if (file) {
            handleFileUpload(file);
        }
    };

    const handleFileUpload = (file: File) => {
        const reader = new FileReader();
    
    reader.onload = (event: ProgressEvent<FileReader>) => {
        if (event.target && typeof event.target.result === 'string') {
            Papa.parse(event.target.result, {
                complete: (result) => {
                    const rows = result.data as string[][];
                    
                    const data: string[][] = [];
                    for (let i = 0; i < rows.length; i++) {
                        const rowData: string[] = [];
                        for (let j = 0; j < Math.min(9, rows[i].length); j++) {
                            if (rows[i][j] === null) {
                                break;
                            }
                            rowData.push(rows[i][j]);
                        }
                        if (rowData.length > 0) {
                            data.push(rowData);
                        }
                    }

                    setSelectedUsers(
                        {
                            role: "",
                            position: "",
                            business_unit: "",
                            timezone: "",
                            location: "",
                            client: "" ,
                            supervisor: "",
                            hr_id: ""
                        }
                    )
                    
                    const keys = data[0]; // First row as keys
                    const values = data.slice(1); // Rest of the rows as values

                    const newUsers = values.map(user => user[0]);
                    setUserButtonSelected(data[1][0]);
                    setUsersPreview(newUsers);
                    setOpenDropView(false);
                    setUserSelected(data[1][0]);

                    let newDataFormat = values.map(row => {
                        let obj: any = {
                            role: "",
                            position: "",
                            business_unit: "",
                            timezone: "",
                            location: "",
                            client: "" ,
                            supervisor: "",
                            hr_id: ""
                        };
                        keys.forEach((key, index) => {
                            if (key !== '') {
                                obj[key] = row[index];
                            }
                        });
                        return obj;
                    });

                    newDataFormat = newDataFormat.filter(item => item.email !== "");
                    
                    setAllUsersInfo(newDataFormat);

                    const dataFromUserSelected = newDataFormat.filter(item => item.email === data[1][0])[0];


                    setRoleBucket(dataFromUserSelected["role"]);
                    setPositionBucket(dataFromUserSelected["position"]);
                    setBusinessUnit(dataFromUserSelected["business_unit"]);
                    setTimeZoneBucket(dataFromUserSelected["timezone"]);
                    setLocationBucket(dataFromUserSelected["location"]);
                    setClientBucket(dataFromUserSelected["client"]);
                    setSupervisorBucket(dataFromUserSelected["supervisor"]);
                },
                error: (error: any) => {
                    console.error('Error parsing CSV:', error);
                    
                    setOpenDropView(false);
                }
            });
        }
    };

    reader.onerror = (error) => {
        console.error('Error reading file:', error);
    };

    reader.readAsText(file);
    
    };

    const usersToShow = usersPreview?.map((user: any) => {
        return {
            name: user,
            email: ''
        }
    })
    const _getTypeSchedule = async (word: string): Promise<AutoCompleteItem<TypeEventScheduleEntity>[]> => {
        
        const mapped = usersToShow.map((item: any) => {
            return {
                label: item.name,
                id: '',
                aditionalValue: '',
            }
        });
        return mapped;
    }

    const _handleClickIcon = (item: any) => {
        
        setUserSelected(item[0].label.toLowerCase());
        const userSelected = usersToShow.filter((user: any) => user.name.toLowerCase() === item[0].label.toLowerCase());
        
        setUserButtonSelected(userSelected[0].name);

        const dataFromUserSelected = allUsersInfo.filter(item => item.email === userSelected[0].name)[0];

        setRoleBucket(dataFromUserSelected["role"]);
        setPositionBucket(dataFromUserSelected["position"]);
        setBusinessUnit(dataFromUserSelected["business_unit"]);
        setTimeZoneBucket(dataFromUserSelected["timezone"]);
        setLocationBucket(dataFromUserSelected["location"]);
        setClientBucket(dataFromUserSelected["client"]);
        setSupervisorBucket(dataFromUserSelected["supervisor"]);
    }


    const _handelRemoveItem = (loc: string, item: string) => {
        let newValue = selectedUsers[loc].replaceAll(item, "").split(",").filter((item: string) => item !== "").join(",");

        setSelectedUsers({
            ...selectedUsers,
            [loc]: newValue
        })
    }

    function downloadFile() {
        const fileUrl = 'https://itelligence.s3.amazonaws.com/settings/users_setup_template.csv';
        const fileName = 'bulk_import_template.csv';
        // Create an anchor element
        const anchor = document.createElement('a');
        anchor.href = fileUrl;
        anchor.setAttribute('download', fileName);
    
        // Programmatically trigger a click on the anchor
        document.body.appendChild(anchor);
        anchor.click();
    
        // Clean up
        document.body.removeChild(anchor);
    }
    
    useEffect(() => {
        firstCall();
        
        if (dropdownOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [dropdownOpen]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>

        {
            loadingUpdate ?
            <LoadingComponent /> 
            :
            <div>
                
                <p className='update_title'>User Creation</p>
                <p className='title_information_user_container'>Bulk Data Import</p>
                <div className='bulk_user_import'>
                    
                    <div style={{justifyContent: "start",  marginBottom: "0px", paddingLeft: "20px", width: "fit-content", minWidth: "300px"}}>
                    <DropDownComponent
                                onSearch={_getTypeSchedule}
                                text={userButtonSelected ? userButtonSelected : "No data imported"}
                                icon={<Icons.PersonOutlined />}
                                onClickIcon={() => _handleClickIcon}
                                onSelected={(e) => _handleClickIcon(e)}
                                type={DropDownType.MAIN}
                                colorLine='#80ACFF' />
                    </div>
                    <div style={{width: "fit-content", display: "flex", marginRight: "20px"}}>
                        <div style={{width: "10px"}}></div>
                        <ButtonComponent text={"Download .csv"} type={ButtonType.MAIN} onClick={() => downloadFile()} icon={<Icons.Download />} />
                        <div style={{width: "10px"}}></div>
                        <ButtonComponent text={"Load .csv File"} type={ButtonType.MAIN} onClick={() => _openDropView()} icon={<Icons.Plus />} />
                    </div>
                </div>
                
                {
                    openDropView &&

                    <div>

            <div className='drop_loader_view' 
            
                onDrop={handleDrop}
                onDragOver={handleDragOver}
                onClick={() => setOpenDropView(false)}
                        >
                            {
                                /**
                                 * 
                                 * <div onClick={() => setOpenDropView(!openDropView)}>close</div>
                                 */
                            }
                            
                            <div>
                            <label htmlFor="fileInput"
                                className='label_drop_content'
                            >
                                <p className='drop_message_bulk'>DROP YOUR CSV FILE HERE TO UPLOAD IT</p>
                                
                            </label>
                            </div>
                            <input 
                                id="fileInput" 
                                type="file" 
                                
                                onChange={handleInputChange}
                                accept=".xlsx,.xls" 
                                style={{ display: 'none' }} 
                            />
                        </div>
                    </div>
                }

                {allUsersInfo.length === 0 ? (
                    /* ─── Single-user mode: render the onboarding wizard ─── */
                    <UserOnboardingWizard onCsvUploaded={(users) => {
                        // This callback is available if the wizard needs to trigger CSV mode in the future.
                        // Currently CSV upload is handled by the Bulk Data Import section above.
                        setAllUsersInfo(users);
                    }} />
                ) : (
                    /* ─── CSV bulk mode: render existing editing fields unchanged ─── */
                    <>
                <p className='title_information_user_container'>User information</p>
                <p>Please enter the user's unique information. This data will customize the user's interaction with the intelligence modules.</p>

            <div className="container_update top">

            <div>
                <div className='user_list_title'>Select a Role:</div>
                <SearchDropdown 
                    data={allRolesData}
                    onSelect={handleItemSelect}
                    selected={roleBucket}
                    id={"role"}
                    editable={false}
                />
            </div>
            
            <div>
                <div className='user_list_title'>Select a Position:</div>
                <SearchDropdown 
                    data={allPositionsData}
                    onSelect={handleItemSelect}
                    selected={positionBucket}
                    id={"position"}
                    editable={true}
                />
            </div>

            <div>
                <div className='user_list_title'>Select a Business Unit:</div>
                <SearchDropdown 
                    data={allBUnitsData}
                    onSelect={handleItemSelect}
                    selected={businessUnitBucket}
                    id={"business_unit"}
                    editable={true}
                />
            </div>
            
            <div>
                <div className='user_list_title'>Select a Time Zone:</div>
                <SearchDropdown 
                    data={configTimeZones}
                    onSelect={handleItemSelect}
                    selected={timeZoneBucket}
                    id={"timezone"}
                    editable={false}
                />
            </div>

            <div>
                <div className='user_list_title'>Select a HR id:</div>
                <SearchDropdown 
                    data={[]}
                    onSelect={handleItemSelect}
                    selected={''}
                    id={"hr_id"}
                    editable={true}
                />
            </div>

            </div>

            <p className='title_information_user_container'>Team Information</p>
            <p>This section pertains to the team details visible to the user on the platform. The level of detail for these inputs varies based on the user's role. Each field can accept multiple entries, separated by commas, to represent users associated with various teams.</p>

            <div className="container_update bottom">
            {
                showLocationField &&
                <div>
                    <div className='user_list_title'>Select a Location:</div>
                    <SearchDropdown 
                        data={configLocations}
                        onSelect={handleItemSelect}
                        selected={locationBucket}
                        id={"location"}
                        editable={false}
                        dropUp={true}
                    />
                    {
                        selectedUsers["location"] !== "" &&
                        <div style={{display: "flex"}}>
                            {
                                selectedUsers["location"].split(",").map((location: string, index: string) => {
                                    return(
                                        <div key={index} className='item_option_selected' style={{display: 'flex'}}>
                                            {location}
                                            <div style={{cursor: "pointer"}} onClick={() => _handelRemoveItem("location", location)}>
                                                <Icons.Trash />
                                            </div>
                                        </div>
                                    )
                                })    
                            }
                        </div>
                    }
                    
                </div>
            }

            {
                showClientField &&
                <div>
                    <div className='user_list_title'>Select a Client:</div>
                    <SearchDropdown 
                        data={configClients.length > 0 ? configClients : allBUnitsData}
                        onSelect={handleItemSelect}
                        selected={businessUnitBucket}
                        id={"client"}
                        editable={true}
                        dropUp={true}
                    />
                    {
                        selectedUsers["client"] !== "" &&
                        <div style={{display: "flex"}}>
                            {
                                selectedUsers["client"].split(",").map((client: string, index: string) => {
                                    return(
                                        <div key={index} className='item_option_selected' style={{display: 'flex'}}>
                                            {client}
                                            <div style={{cursor: "pointer"}} onClick={() => _handelRemoveItem("client", client)}>
                                                <Icons.Trash />
                                            </div>
                                        </div>
                                    )
                                })    
                            }
                        </div>
                    }
                </div>
            }

{
                showSupervisorField &&
                <div>
                    <div className='user_list_title'>Select a Supervisor:</div>
                    <SearchDropdown 
                        data={allSupervisorsData}
                        onSelect={handleItemSelect}
                        selected={supervisorBucket}
                        id={"supervisor"}
                        editable={true}
                        dropUp={true}
                    />
                    {
                        selectedUsers["supervisor"] !== "" &&
                        <div style={{display: "flex"}}>
                            {
                                selectedUsers["supervisor"].split(",").map((supervisor: string, index: string) => {
                                    return(
                                        <div key={index} className='item_option_selected' style={{display: 'flex'}}>
                                            {supervisor}
                                            <div style={{cursor: "pointer"}} onClick={() => _handelRemoveItem("supervisor", supervisor)}>
                                                <Icons.Trash />
                                            </div>
                                        </div>
                                    )
                                })    
                            }
                        </div>
                    }
                </div>
            }
            
        </div>
        <div className="floating_button">
            <ButtonComponent text={isSubmitting ? "Creating..." : "Create"} type={ButtonType.DANGER} onClick={_handleUpdateUsers} icon={<Icons.AddPeople />} disabled={isSubmitting} isLoading={isSubmitting} />
        </div>
                    </>
                )}
        </div>
        }
    </>
        
    );
};

export default UserUpdatePage;